import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { MenuService } from 'src/app/core/services/core/menu.service';

@Directive({
  selector: '[deleteIonBackdrop]'
})
export class DeleteIonBackdropDirective implements OnInit {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private menuService: MenuService
  ) {}

  ngOnInit() {
    this.menuService.menuReady$.subscribe(() => {
      const shadow =
        this.el.nativeElement.shadowRoot ||
        (this.el.nativeElement.attachShadow &&
          this.el.nativeElement.attachShadow({ mode: 'open' }));
      if (shadow) {
        this.renderer.removeChild(this.el, shadow.lastElementChild, false);
        // This directive changes box-shadow too
        this.renderer.setStyle(
          shadow.firstChild,
          'box-shadow',
          '0 0 12px 0 rgba(0, 0, 0, 0.6)'
        );
      }
    });
  }
}
